import { render } from "./DocxViewer.vue?vue&type=template&id=c05c8616&scoped=true"
import script from "./DocxViewer.vue?vue&type=script&lang=js"
export * from "./DocxViewer.vue?vue&type=script&lang=js"

import "./DocxViewer.vue?vue&type=style&index=0&id=c05c8616&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05c8616"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
